import moment from 'moment';
import swal from "sweetalert";
import { mapMutations } from 'vuex'

export const mix = {
  inject: ['TrainerMethods', 'module_name', 'http'],
  data() {
    return {
      maintimer: '',
      timer: {
        total: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      past_react_minus: [],
      past_react_plus: [],
    }
  },
  computed: {
    react_minus() {
      return this.$store.state.react_minus;
    },
    react_plus() {
      return this.$store.state.react_plus;
    },
    isHw() {
      return this.$route.params.isHomework ? this.$route.params.isHomework : false;
    }    
  },
  methods: {
    ...mapMutations({
      completeHomework: 'student/completeHomework'
    }),
    /** Запускаем таймер */
    startTimer() {
      //this.timer = null;
      let duration = moment.duration({
        'seconds': 0,
      });
      let app = this;
      clearInterval(this.maintimer);
      this.timer = {
        total: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
      this.maintimer = setInterval(function () {
        duration = moment.duration(duration.asSeconds() + 1, 'seconds');
        app.timer = duration._data;
        app.timer.total_ms = duration._milliseconds;
        if (app.finish) {
          clearInterval(app.maintimer);
        }
      }, 1000);
    },
    /** Обнуляем таймер */
    nullTimer() {
      this.timer = {
        total: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    },
    /** Случайное число */
    randomInteger(min, max) {
      let rand = min + Math.random() * (max + 1 - min);
      return Math.floor(rand);
    },


    /** Проверяем - ДЗ ли это */
    checkHomework(stats) {
      console.log('check homework');
      let homework_id = this.$route.params.homework_id ? this.$route.params.homework_id : null;
      let isHomework = this.isHw;
      stats.homework_id = homework_id;
      stats.isHomework = isHomework;

      this.updateHomework();

      if (this.$route.params.is_matrius) {
        this.updateMatriusTask()
      }      

      return stats;
    },
    /** Проверяем домашнее ли это задание и сколько выполнено */
    checkFinishHomework() {
      if (this.isHw || this.$route.params.is_matrius) {
        return (this.$route.params.total === this.$route.params.qnt) ? true : false;
      }
    },    
    /** Проверяем коины */
    checkCoins(arr) {
      console.log('CHECK COINS', arr);
      if (!arr.coin) return false;

      if (arr.coin.has_coin) {
        swal('Поздравляем! Ты заработал дженкоин!', `Ты два дня подряд выполнял домашнюю работу и за это получаешь Дженкоин!`, 'success');
        let val = {
          param: 'coin_balance',
          value: arr.coin.balance
        };
        this.$store.commit('updateUserParam', val);
      } else {
        swal('Домашнее задание выполнено!', `Ты выполнил домашнюю работу!`, 'success');
      }

    },
    updateMatrius() {
      let total = +this.$route.params.total;
      let qnt = +this.$route.params.qnt;
      if (total < qnt) total++;
      this.$route.params.total = total;
    },
    /** Обновляем ДЗ */
    updateHomework() {
      //console.log('Update Homework');
      if (!this.$route.params.isHomework) return false;

      let total = +this.$route.params.total;
      let qnt = +this.$route.params.qnt;
      if (total < qnt) total++;
      this.$route.params.total = total;

      let updateParams = { id: this.$route.params.homework_id, date: this.$route.params.date}
      this.completeHomework(updateParams)
    },
    updateMatriusTask() {
      let total = +this.$route.params.total;
      let qnt = +this.$route.params.qnt;
      if (total < qnt) total++;
      this.$route.params.total = total;
    },
    /** Действие при остановке тренажера */
    onStopTrainer() {
      this.TrainerMethods.commitVal(false, 'start', this.module_name, this);
      
      if (this.$route.params.isHomework || this.$route.params.is_matrius) {
        this.$router.push({ name: 'student_homework' });
      } 
    },
    /** Проверяем, была ли реакция */
    checkReaction(type) {
      //console.log(type);
      let file = _.sample(this[type]);
      //console.log(file);
      if (_.difference(this[type], this['past_' + type]).length === 0) {
        this['past_' + type] = [];
      }
      if (_.indexOf(this['past_' + type], file) === -1) {
        //console.log('Добавляем и возвращаем реакцию');
        this['past_' + type].push(file);
        return file;
      } else {
        //console.log('Реакция уже была, запускаем заново');
        return this.checkReaction(type);
      }
    },

    /** Работа со статусами */
    checkScoreStatus(scores) {
      if (scores === 0 || this.user.role.code !== 'student') return;

      let all_scores = this.user.scores;
      let user_id = this.user.id;
      let total = all_scores + scores;
      let status = this.user.status;
      console.log('checkScoreStatus', all_scores, total);

      let arr = {
        user_id: user_id,
        user_scores: total
      }

      if (!status || status.length === 0) {
        this.changeUserStatus(arr);
      } else {
        if (status.scores_to <= total) {
          this.changeUserStatus(arr);
        }
      }

    },
    changeUserStatus(arr) {
      console.log('ChangeUserStatus');
      this.http.post('onChangeUserStatus', arr).then((res)=>{
        console.log(res);
        if (!_.isEmpty(res.data)) {
          if (res.data) {
            this.$store.commit('updateUserStatus', res.data);
            let status = res.data.title;
            swal('У тебя новый статус!', `Поздравляем! Ты получаешь статус "${status}"!!!`, "success");
          }
        }
      });
    },
    /** Подгрузка текста для домашки */
    async checkHasText() {
      if (!this.params.text && this.params.text_id) {
        let data = {
          'text_id': this.params.text_id
        }
        this.params.text = await this.http.post('onGetFullText', data).then(res => res.data)
      }
    },
    // фиксация таймера в текстах
    fixMenu() {
      const menu = document.querySelector('.train__info')
      document.addEventListener('scroll', () => {
        if (window.scrollY >= 342) {
          menu.classList.add('fixed-timer')
        } else {
          menu.classList.remove('fixed-timer')
        }
      })
    }
  },
  mounted() {
    if (this.$route.params.is_matrius) {
      
      let data = {
        id: this.$route.params.student_task_id,
        trainer_id: this.$route.params.trainer_id
      }
      this.http.post('onReadMatriusTask', data).then(res => {
        console.log(res.data)
      })
      .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
    }
  }
};